import { get, patch, post, destroy } from './httpClient'

export const getReviews = (query) => get('/review', query)
export const addReview = (body) => post('/review/create', body)
export const updateReview = (id, body) => patch('/review/update/' + id, body)
export const deleteReview = (id) => destroy('/review/delete/' + id)
